export class ConsentModel {
  constructor (jsonObj) {
    this.id = Number(jsonObj.id) || null
    this.title = jsonObj.title || null
    this.htmlContent = jsonObj.htmlContent || null
    this.agreeLabel = jsonObj.agreeLabel || null
    this.disagreeLabel = jsonObj.disagreeLabel || null
    this.pdfLink = jsonObj.url || null
    this.userResponse = jsonObj.userResponse === false ? false : jsonObj.userResponse || null
    this.isTerminated = jsonObj.isTerminated || null
    this.thanksResponse = jsonObj.thanksResponse || null
  }
}



// WEBPACK FOOTER //
// ./src/model/consent.js